import type { SVGProps } from 'react';
const SvgDinnerDining = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#dinner_dining_svg__a)">
      <path
        fill="currentColor"
        d="M2 19h20l-2 2H4l-2-2ZM5 6h1v1H5V6Zm0-2h1v1H5V4Zm4 0v1H7V4h2Zm0 3H7V6h2v1Zm-3 8.23c-.36.11-.69.28-1 .47V8h1v7.23Zm-2 1.29c-.38.44-.68.93-.84 1.48h16.82c.01-.16.03-.33.03-.5a5.497 5.497 0 0 0-10.58-2.1c-.59-.25-1.24-.4-1.93-.4-.17 0-.33.02-.5.04V8h2c1.03.06 1.9-.96 2-2h10V5H11c-.1-1.05-.97-1.97-2-2H3v1h1v1H3v1h1v1H3v1h1v8.52Z"
      />
    </g>
    <defs>
      <clipPath id="dinner_dining_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDinnerDining;
